import { observable, reaction, computed, action, makeObservable, values, runInAction, toJS } from 'mobx'
import Specialist from './Specialist';
import { parseShape, wrapPromise } from './utils';
import { GET_ALL_SPECIALIST, GET_ONE_SPECIALIST, GET_SPECIALIST_DETAILS } from 'api/graphql/specialists';

class SpecialistStore {

    _specialists = [];
    stale = true;

    constructor(model) {
        this.model = model;
        makeObservable(this, {
            model: false,
            _specialists: observable,
            videos: computed,
            specialists: computed,
            teasers: computed
        })
    }

    get specialists() {
        return this._specialists;
    }

    get teasers() {
        // console.log(this._specialists, this._specialists.filter(spec => {
        //     console.log(spec);
        //     return spec.teaserLoaded === true
        // }))
        return this._specialists.filter(spec => spec.teaserLoaded);
    }

    page(slug) {
        return this._specialists.find(spec => spec.pageLoaded && spec.data.slug === slug);
    }

    get specialistsData() {
        if (this.teasers.length > 0 && !this.stale) {
            return { read: () => this.teasers } ;
        }
        this.stale = false;
        return wrapPromise(this.getSpecialists());
    }

    oneSpecialistData = (slug) => {
        const specialist = this.page(slug);
        if (specialist) {
            return { read: () => specialist };
        }
        const promise = this.getOneSpecialist(slug);
        return wrapPromise(promise);
    }

    oneSpecialistDetailsData = (slug) => {
        return wrapPromise(this.getOneSpecialistDetails(slug));
    }

    setLoadedSpecialists = (specialists) => {
        runInAction(() => {
            specialists.forEach(json => this.updateSpecialistFromServer(json, { teaserLoaded: true }));
        })
        return this.teasers;
    }

    getSpecialists = () => {
        return this.model.apollo.query( {
            query: GET_ALL_SPECIALIST,
        }).then((response) => {
            const data = response.data;
            const parsed = parseShape(data)['sortedSpecialist'];
            runInAction(() => {
                parsed.forEach(json => this.updateSpecialistFromServer(json, { teaserLoaded: true }));
            })
            return this.teasers;
        });
    }

    getOneSpecialist = (slug) => {
        return this.model.apollo.query( {
            query: GET_ONE_SPECIALIST,
            variables: { slug }
        } ).then((response) => {
            const data = response.data;
            const parsed = parseShape(data)['allSpecialist'];
            runInAction(() => {
                parsed.forEach(json => this.updateSpecialistFromServer(json, { pageLoaded: true }));
            })
            return this.getSpecialistBySlug(slug);
        });
    }

    getOneSpecialistDetails = (slug) => {
        return this.model.apollo.query( {
            query: GET_SPECIALIST_DETAILS,
            variables: { slug }
        } ).then((response) => {
            const data = response.data;
            const parsed = parseShape(data)['sortedSpecialist'];
            runInAction(() => {
                parsed.forEach(json => this.updateSpecialistFromServer(json));
            })
            return this.getSpecialistBySlug(slug);
        });
    }

    getSpecialistByName = (name) => {
        return this._specialists.find(spec => spec.name === name);
    }

    getSpecialistBySlug = (slug) => {
        return this._specialists.find(spec => spec.data.slug === slug);
    }

    getSpecialistById = (id) => {
        return this._specialists.find(spec => spec.id === id);
    }

    updateSpecialistFromServer(json, options) {
        let spec = this._specialists.find(spec => spec.id === json.id)
        if (!spec) {
            spec = new Specialist(this.model, json, options);
            const specOpenEvents = this.model.events.getEventsBySpec(spec.id);
            spec.openEvents = specOpenEvents;
            this._specialists.push(spec);
            this._specialists.sort((spec1, spec2) => spec1.data.sortOrder - spec2.data.sortOrder)
        } else {
            spec.updateFromJson(json, options)
        }
    }

    allProblems(specIds) {
        const specialists = this._specialists.filter(spec => specIds.includes(spec.id));
        const problems = new Map();
        for (const spec of specialists) {
            for (const problem of spec.problems) {
                if (problems.has(problem.id)) { continue; }
                problems.set(problem.id, problem.title);
            }
        }
        return problems;
    }

    allCities(specIds) {
        const specialists = this._specialists.filter(spec => specIds.includes(spec.id));
        const cities = new Map();
        for (const spec of specialists) {
            for (const [id, city] of spec.cities.entries()) {
                if (cities.has(id)) { continue; }
                cities.set(id, city);
            }
        }
        return cities;
    }

    allCityDistricts(specIds, city) {
        const specialists = this._specialists.filter(spec => specIds.includes(spec.id));
        const districts = new Map();
        for (const spec of specialists) {
            for (const [id, district] of spec.districts.entries()) {
                if (districts.has(id)) { continue; }
                if (!id.startsWith(city)) { continue; }
                districts.set(id, district);
            }
        }
        return districts;
    }

    get videos() {
        const specialists = this._specialists.filter(spec => spec.data.video !== null && spec.data.video.includes('youtube'));
        return specialists.map(spec => spec.data.video);
    }


}

export default SpecialistStore;
